// Expose jQuery as a global, for the plugins imported after this module (see app.js), our scripts and the inline
// scripts in the pages.
import $ from 'jquery';

window.$ = window.jQuery = $;

export default $;
